<template>
    <div id="app">
        <!--<img id="statusbar" src="./assets/images/statusbar.svg" alt="">-->
        <transition name="fade">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import Login from './views/Login'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  components: {
    Login
  }
}
</script>

<style lang="scss">
    @import "./styles/app";

    #statusbar {
        position: fixed;
        top: 0;
        right: 0;
        width: 100%;
        z-index: 10;
    }
    #app {
        position: relative;
    }

    #app > div {
        height: 100%;
        width: 100%;
        top: 0;
        right: 0;
        position: absolute;
    }



</style>
